import { $Q, $Qll } from "graditify-utils";
import {
  sectionHandle,
  updateButton,
  updateButtonVariant,
  updateElement,
  updateMaxQuantity,
  updatePrice,
  updateTags,
  updateProductCardButton
} from "./component-card-product-update.submodule";
import { changeIndexSlider } from "./component-product-core-slideto.submodule";

/**
 * @param {HTMLElement} parent - Dom element parent of all selectors options
 * @returns Array of nodes
 */
 const options = (parent) => $Qll('.js-option', parent);

 /**
  * @param {Array} options - Array of option names
  * @returns separate options with "/"
  */
 const buildOption = (options) => options.join(' / ');

/**
 * optionChecked
 * Iterates and searches for the options that were selected
 *
 * @param {HTMLElement} parent - Dom element parent of all selectors options
 * @returns A variant name - string reference
 */
 function optionsChecked(parent) {
  let myOptions = [];

  options(parent).forEach(
    (option) => {
      if (option.type === "radio") {
        if (option.checked === true) {
          myOptions = [...myOptions, option.value]
        }
      } else {
        myOptions = [...myOptions, option.value]
      }
    },
  )
  return buildOption(myOptions);
}

/**
 * selectVariant
 * Searches for a selected variant in an object stored in
 * the DOM (input[id="variants"])
 *
 * @param {HTMLElement} parent - Dom element parent of all selectors options
 * @returns Replacement of id in the dom (on input[name="id"])
 */
export function selectVariant(parent, isMainProduct = false) {
  const variantName = optionsChecked(parent);
  const variants = JSON.parse($Q('#variants', parent).value);

  const variantFilter = variants.filter(
    (variant) => variant.title === variantName,
  )

  $Q('[name="id"]', parent).value = variantFilter[0].id;
  if (isMainProduct) $Q('[name="id"]', $Q('.sticky-cart')).value = variantFilter[0].id;
}

const addLoaderButton = (button) => {
  if (!button) return;
  button.disabled = true;
  button.innerHTML = '<div id="loading"></div>';
}

/**
 * Section rendering to dynamic price and available data
 *
 * @param {HTMLElement} param0 - Node with event change
 *
 * @author Andres Briñez
 * @author Cristian Velasco
 * @version 2.0
 */
export async function queryVariants(scope, isMainProduct = false, isQuickView = false) {
  const addCartBtn = $Q('.btn-cart-js:not(.upsell-btn)', scope);
  const { value, dataset, title } = $Q('[name="id"]', scope);
  const variantName = optionsChecked(scope);

  if (isMainProduct) changeIndexSlider(variantName, scope.closest('.product-js'));
  addLoaderButton(addCartBtn);

  if (isMainProduct) {
    const addCartBtnSticky = $Q('.btn-cart-js', $Q('.sticky-cart'));
    addLoaderButton(addCartBtnSticky);
  }

  const {
    available,
    button,
    reference,
    messageAvailable,
    color,
    tag,
    price,
    productCardButton,
    imageSelected,
    imageSelectedSticky,
    maxQuantity
  } = await sectionHandle(dataset.variant, value);

  updateElement(reference, scope, '.product-core__reference-js');
  updateTags(tag, scope);

  if (isMainProduct || isQuickView) {
    updateElement(color, scope, '#selected-color');
    updateElement(messageAvailable, scope, '.product-core__message-js');
    updateMaxQuantity(maxQuantity, scope, '#quantity', 'data-quantity');
    updateButton(available, scope, button, isQuickView);
    $Q('#quantity', scope).value = 1;
  }

  if (isMainProduct) {
    updateElement(imageSelectedSticky, $Q('.sticky-cart'), '.image-js');
    updateButton(available, $Q('.sticky-cart'), button);
  } else {
    updateElement(imageSelected, scope, '.image-js');
    updateProductCardButton(available, scope, productCardButton);
    updateButtonVariant(scope, value);
  }

  updatePrice(price, scope);
}
